var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 440,
    viewBox: "0 0 584 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M508.661 424.962C537.718 413.986 563.988 390.51 569.684 359.969C574.378 334.778 564.702 309.203 552.939 286.414C541.176 263.624 526.93 241.603 521.439 216.577C511.214 170.037 532.31 118.407 512.271 75.1741C506.245 62.1945 496.83 50.9987 486.193 41.463C439.678 -0.0824204 369.829 -9.38486 310.248 8.98678C250.666 27.3584 200.925 70.2484 164.334 120.712C149.236 141.512 136.114 163.726 119.658 183.442C97.7247 209.703 69.2584 232.753 59.733 265.559C52.8017 289.267 56.9879 314.952 65.2231 338.277C77.8916 374.032 132.477 437.626 158.459 437.503C216.366 437.215 327.473 440.055 381.153 437.997C421.368 436.419 466.566 440.851 508.661 424.962Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.439 376.79C259.066 380.7 257.858 385.187 259.848 388.823C261.179 390.85 262.971 392.533 265.078 393.735L284.019 406.604C287.656 409.074 291.513 411.612 295.877 411.942C300.242 412.271 305.197 409.486 305.567 405.081C306.007 400.046 300.722 396.602 298.252 392.184C295.013 386.394 296.797 379.218 298.485 372.797C302.742 356.636 305.851 340.195 307.791 323.596C303.907 322.004 292.597 314.883 288.575 316.063C284.046 317.435 279.956 330.099 277.938 334.229C271.118 347.99 265.271 362.212 260.439 376.79Z",
    fill: "#F1AF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77 268.193C291.856 282.147 286.64 296.141 278.762 308.682C278.476 309.045 278.326 309.496 278.337 309.958C278.462 310.392 278.733 310.771 279.105 311.028C287.025 317.957 295.576 325.188 305.993 326.683C306.672 326.84 307.383 326.777 308.024 326.505C308.626 326.079 309.07 325.466 309.287 324.762C315.93 309.382 318.277 292.533 318.058 275.876C317.914 267.556 317.254 259.253 316.081 251.015C315.807 249.012 315.656 240.121 313.913 239.078C311.264 237.514 308.354 242.975 307.201 244.69C302.425 251.838 299.597 260.07 296.77 268.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.305 241.603C318.305 241.603 312.114 243.922 307.077 261.346C302.04 278.771 290.017 321.003 290.017 321.003C290.017 321.003 308.614 330.292 313.267 326.807C317.92 323.322 318.305 241.603 318.305 241.603Z",
    fill: "url(#paint0_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.065 223.656C381.194 223.341 391.447 223.835 401.192 226.579C410.937 229.323 420.201 234.509 426.597 242.371C433.68 251.07 436.781 262.444 437.495 273.626C438.209 284.808 436.727 296.018 435.601 307.186C432.964 333.328 432.267 359.629 433.515 385.873C433.817 392.157 437.413 424.962 432.993 429.449C430.248 432.275 435.738 435.102 431.827 436.035C399.847 443.718 342.392 439.945 312.114 427.13C304.414 423.865 296.687 419.323 292.899 411.887C288.781 403.833 299.899 371.906 301.23 362.946C305.265 335.606 308.175 308.119 309.959 280.486C310.742 268.262 309.836 255.09 312.348 243.085C314.173 234.372 319.787 231.998 327.885 229.858C342.001 226.187 356.485 224.107 371.065 223.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.376 366.692C396.319 372.249 394.933 378.052 391.131 382.251C388.123 385.256 384.445 387.504 380.398 388.809C361.32 395.999 339.565 394.874 321.283 403.902C319.993 404.466 318.806 405.241 317.769 406.193C314.242 409.678 315.23 415.797 318.03 419.913C324.248 429.01 336.34 431.562 347.251 433.25C373.412 437.366 400.121 440.727 426.268 436.515C427.691 436.412 429.051 435.892 430.18 435.02C431.082 433.972 431.659 432.685 431.84 431.315C437.77 404.999 433.103 377.6 432.993 350.625C432.993 335.066 434.366 319.494 433.309 303.976C432.777 294.319 430.768 284.801 427.352 275.753C424.923 269.606 417.813 256.037 413.545 268.632C406.764 288.65 404.815 310.232 402.372 331.101C401.041 342.997 399.613 354.906 397.376 366.692Z",
    fill: "url(#paint1_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.556 414.933H183.728C177.504 414.933 172.459 419.976 172.459 426.197C172.459 432.419 177.504 437.462 183.728 437.462H405.556C411.78 437.462 416.825 432.419 416.825 426.197C416.825 419.976 411.78 414.933 405.556 414.933Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.556 414.933H183.728C177.504 414.933 172.459 419.976 172.459 426.197C172.459 432.419 177.504 437.462 183.728 437.462H405.556C411.78 437.462 416.825 432.419 416.825 426.197C416.825 419.976 411.78 414.933 405.556 414.933Z",
    fill: "url(#paint2_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.593 244.978C342.05 244.251 339.497 239.682 341.528 228.678C341.748 227.457 342.036 226.277 342.365 225.097C342.365 224.878 342.489 224.658 342.544 224.438C343.038 222.737 343.601 221.036 344.15 219.348C345.678 215.298 346.486 211.012 346.538 206.684C346.414 203.529 346.167 200.249 347.334 197.341C348.455 194.872 350.212 192.746 352.426 191.18C357.326 187.407 371.641 180.314 374.387 189.685C375.608 193.691 374.716 198.356 374.661 202.458C374.386 208.337 375.466 214.2 377.818 219.595C380.81 225.605 357.751 246.762 346.593 244.978Z",
    fill: "#F1AF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.367 222.628C343.367 222.628 368.677 213.023 373.563 197.835L346.593 206.657C346.593 206.657 345.948 220.556 343.367 222.628Z",
    fill: "url(#paint3_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.98 255.474C409.397 284.179 414.158 313.069 425.815 339.429C426.16 340.402 426.74 341.274 427.504 341.968C428.734 342.732 430.176 343.088 431.621 342.983C442.912 343.226 453.958 339.68 462.997 332.912C465.742 330.84 468.323 328.192 468.556 324.968C468.562 323.239 468.221 321.527 467.554 319.933C460.547 299.577 452.367 279.645 443.054 260.235C439.596 253.046 434.956 244.621 426.584 241.452C416.51 237.651 412.68 247.955 411.98 255.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.939 271.884C370.447 263.967 375.951 254.404 381.386 244.95C384.694 239.188 388.084 233.165 388.551 226.524C388.668 225.77 388.549 224.998 388.208 224.315C387.877 223.839 387.446 223.441 386.945 223.149L376.637 216.165C376.459 222.49 371.916 227.923 366.727 231.559C361.237 235.456 345.522 239.723 348.885 247.804C349.722 249.849 362.061 272.803 362.939 271.884Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.939 271.884C370.447 263.967 375.951 254.404 381.386 244.95C384.694 239.188 388.084 233.165 388.551 226.524C388.668 225.77 388.549 224.998 388.208 224.315C387.877 223.839 387.446 223.441 386.945 223.149L376.637 216.165C376.459 222.49 371.916 227.923 366.727 231.559C361.237 235.456 345.522 239.723 348.885 247.804C349.722 249.849 362.061 272.803 362.939 271.884Z",
    fill: "url(#paint4_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.588 420.092L481.705 408.608C485.26 407.922 488.965 407.236 491.779 404.903C495.636 401.802 496.995 396.369 496.432 391.443C495.869 386.518 493.687 381.949 491.518 377.476C482.981 359.804 465.66 328.083 465.55 329.935C455.036 332.158 446.335 332.267 437.303 338.044C435.748 338.883 434.435 340.106 433.488 341.597C429.878 348.457 439.746 358.473 443.095 363.687C444.379 365.354 445.237 367.308 445.593 369.381C445.665 370.846 445.393 372.307 444.797 373.648C441.544 381.633 429.96 386.285 422.837 390.387C413.523 396.016 403.081 399.52 392.257 400.65C383.857 401.363 375.279 400.279 367.071 402.159C362.037 403.358 357.319 405.625 353.239 408.807C349.159 411.988 345.811 416.01 343.422 420.599C348.308 423.7 354.663 421.903 360.291 420.49C370.717 417.904 381.496 417.038 392.202 417.924C399.147 418.514 418.294 426.554 421.588 420.092Z",
    fill: "#F1AF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64 437.475H158.446L113.55 323.596C112.942 322.077 112.715 320.432 112.891 318.805C113.066 317.178 113.639 315.619 114.557 314.265C115.476 312.91 116.713 311.802 118.16 311.037C119.607 310.271 121.219 309.873 122.856 309.876H256.458C262.929 309.872 269.25 311.817 274.599 315.456C279.948 319.095 284.077 324.26 286.448 330.278L328.64 437.475Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64 437.475H158.446L113.55 323.596C112.942 322.077 112.715 320.432 112.891 318.805C113.066 317.178 113.639 315.619 114.557 314.265C115.476 312.91 116.713 311.802 118.16 311.037C119.607 310.271 121.219 309.873 122.856 309.876H256.458C262.929 309.872 269.25 311.817 274.599 315.456C279.948 319.095 284.077 324.26 286.448 330.278L328.64 437.475Z",
    fill: "url(#paint5_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.993 437.599H158.281L115.622 329.468C115.055 328.027 114.847 326.47 115.019 324.93C115.191 323.391 115.736 321.917 116.607 320.637C117.478 319.356 118.649 318.307 120.018 317.582C121.387 316.857 122.912 316.477 124.462 316.475H251.366C257.512 316.48 263.515 318.331 268.596 321.788C273.677 325.245 277.601 330.148 279.86 335.862L319.993 437.599Z",
    fill: "url(#paint6_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.102 61.7968C345.22 59.382 349.337 56.9261 353.99 56.0205C358.643 55.115 364.971 55.6638 368.114 59.1762C364.038 59.4628 360.067 60.5954 356.454 62.5018C352.84 64.4082 349.664 67.0466 347.128 70.2486C346.892 70.6647 346.518 70.9851 346.071 71.1541C345.688 71.1944 345.302 71.1229 344.959 70.9483C343.065 70.2349 328.873 73.4729 328.049 71.7578C328.091 71.7578 339.359 62.8533 341.102 61.7968Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.102 61.7968C345.22 59.382 349.337 56.9261 353.99 56.0205C358.643 55.115 364.971 55.6638 368.114 59.1762C364.038 59.4628 360.067 60.5954 356.454 62.5018C352.84 64.4082 349.664 67.0466 347.128 70.2486C346.892 70.6647 346.518 70.9851 346.071 71.1541C345.688 71.1944 345.302 71.1229 344.959 70.9483C343.065 70.2349 328.873 73.4729 328.049 71.7578C328.091 71.7578 339.359 62.8533 341.102 61.7968Z",
    fill: "url(#paint7_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.426 166.429C319.629 166.429 327.089 157.239 327.089 145.903C327.089 134.567 319.629 125.377 310.426 125.377C301.224 125.377 293.764 134.567 293.764 145.903C293.764 157.239 301.224 166.429 310.426 166.429Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.844 167.197C322.357 167.197 329.258 158.695 329.258 148.208C329.258 137.72 322.357 129.219 313.844 129.219C305.331 129.219 298.43 137.72 298.43 148.208C298.43 158.695 305.331 167.197 313.844 167.197Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.844 167.197C322.357 167.197 329.258 158.695 329.258 148.208C329.258 137.72 322.357 129.219 313.844 129.219C305.331 129.219 298.43 137.72 298.43 148.208C298.43 158.695 305.331 167.197 313.844 167.197Z",
    fill: "url(#paint8_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.422 109.955L312.279 180.492C312.279 180.492 313.995 207.11 340.389 207.37C372.094 207.686 381.743 189.259 386.561 175.237C391.378 161.215 395.729 120.026 386.561 108.638C377.392 97.2502 325.799 69.2194 308.422 109.955Z",
    fill: "#F1AF8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.475 67.6005C316.04 67.381 301.834 73.1847 296.166 84.9156C294.805 87.6149 294.065 90.5836 293.998 93.6053C293.932 96.6269 294.541 99.6253 295.781 102.382C296.237 103.192 296.596 104.053 296.852 104.947C296.975 105.936 296.975 106.936 296.852 107.925C296.744 110.308 297.224 112.681 298.251 114.835C299.278 116.989 300.82 118.856 302.74 120.273C304.922 121.851 307.571 122.839 309.314 124.883L308.642 111.753C308.487 111.043 308.619 110.301 309.01 109.689C309.401 109.077 310.019 108.645 310.728 108.487L319.087 104.591C319.087 104.591 321.667 106.47 321.983 106.621C323.37 107.212 324.868 107.497 326.375 107.458C329.651 107.536 332.928 107.352 336.175 106.909C343.189 105.908 349.9 103.342 356.447 100.79C356.236 102.819 355.357 104.72 353.949 106.196L375.265 110.312C378.387 114.603 380.903 119.303 382.745 124.28C384.218 128.169 385.187 132.231 385.627 136.367C386.198 141.99 385.671 147.67 384.076 153.092C385.526 151.988 386.795 150.664 387.837 149.168C389.764 150.506 391.897 151.521 394.151 152.173C394.62 152.347 395.128 152.39 395.619 152.297C396.662 152.008 396.882 150.774 396.992 149.786C397.843 140.936 404.431 133.458 407.451 125.007C411.115 114.771 409.262 103.26 403.662 93.779C402.003 90.7749 399.747 88.1416 397.033 86.0407C387.219 78.8512 373.274 82.1441 362.075 78.3847C356.749 76.6011 352.467 73.2121 347.375 70.9757C341.72 68.5746 334.638 67.7102 328.475 67.6005Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.475 67.6005C316.04 67.381 301.834 73.1847 296.166 84.9156C294.805 87.6149 294.065 90.5836 293.998 93.6053C293.932 96.6269 294.541 99.6253 295.781 102.382C296.237 103.192 296.596 104.053 296.852 104.947C296.975 105.936 296.975 106.936 296.852 107.925C296.744 110.308 297.224 112.681 298.251 114.835C299.278 116.989 300.82 118.856 302.74 120.273C304.922 121.851 307.571 122.839 309.314 124.883L308.642 111.753C308.487 111.043 308.619 110.301 309.01 109.689C309.401 109.077 310.019 108.645 310.728 108.487L319.087 104.591C319.087 104.591 321.667 106.47 321.983 106.621C323.37 107.212 324.868 107.497 326.375 107.458C329.651 107.536 332.928 107.352 336.175 106.909C343.189 105.908 349.9 103.342 356.447 100.79C356.236 102.819 355.357 104.72 353.949 106.196L375.265 110.312C378.387 114.603 380.903 119.303 382.745 124.28C384.218 128.169 385.187 132.231 385.627 136.367C386.198 141.99 385.671 147.67 384.076 153.092C385.526 151.988 386.795 150.664 387.837 149.168C389.764 150.506 391.897 151.521 394.151 152.173C394.62 152.347 395.128 152.39 395.619 152.297C396.662 152.008 396.882 150.774 396.992 149.786C397.843 140.936 404.431 133.458 407.451 125.007C411.115 114.771 409.262 103.26 403.662 93.779C402.003 90.7749 399.747 88.1416 397.033 86.0407C387.219 78.8512 373.274 82.1441 362.075 78.3847C356.749 76.6011 352.467 73.2121 347.375 70.9757C341.72 68.5746 334.638 67.7102 328.475 67.6005Z",
    fill: "url(#paint9_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.208 168.747C411.312 168.747 418.692 159.65 418.692 148.427C418.692 137.205 411.312 128.107 402.208 128.107C393.104 128.107 385.724 137.205 385.724 148.427C385.724 159.65 393.104 168.747 402.208 168.747Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.208 168.747C411.312 168.747 418.692 159.65 418.692 148.427C418.692 137.205 411.312 128.107 402.208 128.107C393.104 128.107 385.724 137.205 385.724 148.427C385.724 159.65 393.104 168.747 402.208 168.747Z",
    fill: "url(#paint10_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.521 168.747C417.625 168.747 425.005 159.65 425.005 148.427C425.005 137.205 417.625 128.107 408.521 128.107C399.417 128.107 392.037 137.205 392.037 148.427C392.037 159.65 399.417 168.747 408.521 168.747Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.645 129.727L400.41 130.605L398.447 130.811L390.212 90.2941C385.929 74.2687 375.457 61.9478 362.322 57.1731C360.288 56.464 358.124 56.2065 355.981 56.4184L350.367 56.9261L353.112 56.1989L358.602 54.7445C360.318 54.2714 362.094 54.0541 363.873 54.0997C378.531 54.6348 392.435 66.4481 397.472 83.379L408.645 129.727Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.645 129.727L400.41 130.605L398.447 130.811L390.212 90.2941C385.929 74.2687 375.457 61.9478 362.322 57.1731C360.288 56.464 358.124 56.2065 355.981 56.4184L350.367 56.9261L353.112 56.1989L358.602 54.7445C360.318 54.2714 362.094 54.0541 363.873 54.0997C378.531 54.6348 392.435 66.4481 397.472 83.379L408.645 129.727Z",
    fill: "url(#paint11_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.645 129.727L400.409 130.605L392.174 89.9923C387.823 73.8022 377.255 61.3852 363.996 56.5694C361.945 55.8343 359.754 55.5717 357.586 55.801L353.112 56.1989L358.602 54.7445C360.318 54.2714 362.094 54.0541 363.873 54.0997C378.531 54.6348 392.435 66.4481 397.472 83.379L408.645 129.727Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M235.829 7.07983H34.5747C22.7192 7.07983 13.1083 16.6872 13.1083 28.5386V264.777C13.1083 276.628 22.7192 286.235 34.5747 286.235H235.829C247.685 286.235 257.296 276.628 257.296 264.777V28.5386C257.296 16.6872 247.685 7.07983 235.829 7.07983Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7444 259.535C106.923 259.535 123.281 243.183 123.281 223.012C123.281 202.84 106.923 186.488 86.7444 186.488C66.5656 186.488 50.2076 202.84 50.2076 223.012C50.2076 243.183 66.5656 259.535 86.7444 259.535Z",
    fill: "url(#paint12_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.933 33.5464H34.8626V42.3274H190.933V33.5464Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M195.641 149.018H39.5706V157.799H195.641V149.018Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.512 133.994H39.5706V142.775H150.512V133.994Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.96 133.994H165.693V142.775H239.96V133.994Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.713 78.4121H125.518V86.219H239.713V78.4121Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M223.765 92.2561H101.595V100.063H223.765V92.2561Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.803 78.4121H41.6978V86.219H116.803V78.4121Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.714 105.702H74.6389V113.509H239.714V105.702Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M65.9368 105.702H41.6978V113.509H65.9368V105.702Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M239.7 119.56H130.748V127.366H239.7V119.56Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.803 119.56H41.6978V127.366H116.803V119.56Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9973 91.9268H41.6978V99.7337H89.9973V91.9268Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8425 199.001C92.7014 201.622 92.3445 205.285 92.7425 208.605C92.8664 209.207 92.8664 209.828 92.7425 210.43C92.5605 210.937 92.2807 211.403 91.919 211.802C86.1031 219.029 79.5886 225.665 72.4702 231.614C72.2699 231.808 72.0315 231.957 71.7702 232.053C71.3043 232.15 70.8193 232.082 70.3977 231.861C68.3389 231.052 66.1291 230.174 63.9742 230.695C62.9977 230.987 62.1043 231.506 61.3671 232.209C60.6299 232.913 60.0699 233.781 59.7331 234.743C59.0673 236.682 58.9579 238.768 59.4174 240.766C61.7599 238.818 64.1984 236.988 66.733 235.278L70.3428 238.859C70.5302 239.001 70.6839 239.184 70.793 239.392C70.9021 239.601 70.9639 239.831 70.9742 240.066C70.9039 240.348 70.7565 240.604 70.5487 240.807L65.2233 247.091C66.9749 247.792 68.8853 247.999 70.7465 247.689C72.6076 247.379 74.348 246.565 75.778 245.335C78.5231 242.728 78.9349 237.857 76.2447 235.237L96.6817 212.337C98.0594 213.356 99.7336 213.894 101.447 213.869C103.16 213.844 104.818 213.258 106.166 212.2C107.475 211.094 108.486 209.679 109.11 208.084C109.733 206.488 109.948 204.762 109.735 203.062C107.191 204.586 104.832 206.4 102.707 208.468L98.5895 203.337C100.044 201.965 105.686 198.178 102.021 196.696C99.6052 195.722 96.4072 197.094 94.8425 199.001Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.141 236.019L215.104 229.776C215.104 229.776 207.349 223.656 207.116 224.041L206.8 219.527L213.896 211.98L210.629 206.314C210.629 206.314 201.022 207.878 201.022 208.317C199.168 206.575 197.17 204.991 195.051 203.583L194.749 193.293L188.435 191.578C188.435 191.578 182.657 199.591 183.041 199.81C183.041 199.81 178.594 200.743 176.467 201.416L169.275 195.296L163.785 198.836C163.785 198.836 165.418 206.478 166.063 208.084C164.526 209.771 162.604 211.679 162.604 211.679L152.365 213.325L151.487 219.801C151.487 219.801 158.693 223.698 160.093 224.096C160.122 226.193 160.445 228.276 161.053 230.283L155.467 238.872L159.681 243.867C159.681 243.867 165.267 241.905 167.697 240.834C169.961 242.892 173.187 245.335 173.187 245.335L175.767 255.378L182.3 255.652C182.3 255.652 185.443 248.339 185.773 246.734C187.874 246.5 189.993 246.473 192.1 246.652L201.282 251.468L205.88 246.803C204.554 243.838 203.074 240.943 201.447 238.131C202.03 237.423 202.558 236.671 203.025 235.881L213.141 236.019ZM182.671 236.252C180.102 236.255 177.591 235.496 175.453 234.071C173.316 232.646 171.65 230.62 170.665 228.249C169.68 225.877 169.421 223.267 169.921 220.749C170.42 218.23 171.656 215.916 173.471 214.099C175.286 212.283 177.6 211.045 180.119 210.543C182.638 210.041 185.249 210.297 187.623 211.279C189.996 212.261 192.025 213.925 193.452 216.06C194.879 218.195 195.641 220.705 195.641 223.272C195.638 226.711 194.27 230.008 191.839 232.441C189.408 234.874 186.111 236.245 182.671 236.252Z",
    fill: "url(#paint13_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.556 106.402C301.985 101.6 307.256 98.7458 312.567 97.8814C317.879 97.017 323.314 97.8128 328.626 98.6223C323.479 102.738 309.109 108.871 308.834 109.969C308.641 111.912 308.618 113.867 308.765 115.814C308.958 118.64 309.054 121.604 309.04 124.43C307.714 123.132 306.229 122.007 304.62 121.083C303.237 120.55 301.977 119.742 300.915 118.709C299.526 117.006 298.659 114.939 298.418 112.756C298.177 110.573 298.572 108.366 299.556 106.402Z",
    fill: "url(#paint14_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.459 197.684C363.258 197.558 357.109 196.532 351.204 194.638C350.505 194.428 349.918 193.95 349.572 193.308C349.226 192.666 349.149 191.913 349.358 191.214C349.567 190.516 350.046 189.929 350.688 189.583C351.33 189.237 352.084 189.16 352.782 189.369C366.92 193.622 377.557 193.06 384.351 187.695C393.602 180.437 392.998 166.607 392.998 166.47C392.961 165.742 393.216 165.029 393.705 164.489C394.194 163.949 394.877 163.625 395.605 163.588C396.334 163.552 397.046 163.806 397.587 164.295C398.127 164.784 398.451 165.468 398.488 166.195C398.488 166.868 399.215 183.03 387.741 192.031C382.964 195.79 376.87 197.674 369.459 197.684Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.459 197.684C363.258 197.558 357.109 196.532 351.204 194.638C350.505 194.428 349.918 193.95 349.572 193.308C349.226 192.666 349.149 191.913 349.358 191.214C349.567 190.516 350.046 189.929 350.688 189.583C351.33 189.237 352.084 189.16 352.782 189.369C366.92 193.622 377.557 193.06 384.351 187.695C393.602 180.437 392.998 166.607 392.998 166.47C392.961 165.742 393.216 165.029 393.705 164.489C394.194 163.949 394.877 163.625 395.605 163.588C396.334 163.552 397.046 163.806 397.587 164.295C398.127 164.784 398.451 165.468 398.488 166.195C398.488 166.868 399.215 183.03 387.741 192.031C382.964 195.79 376.87 197.674 369.459 197.684Z",
    fill: "url(#paint15_linear_2292_75315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.632 184.732C354.207 185.523 355.441 186.859 356.104 188.491C356.708 190.824 354.896 193.06 353.03 194.583C351.425 196.012 349.452 196.963 347.334 197.327C344.232 197.698 341.267 196.024 338.687 194.254C337.247 193.376 336.019 192.19 335.091 190.782C332.702 186.584 335.791 181.178 339.84 179.395C344.328 177.46 349.104 182.413 352.632 184.732Z",
    fill: "#88C139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.632 184.732C354.207 185.523 355.441 186.859 356.104 188.491C356.708 190.824 354.896 193.06 353.03 194.583C351.425 196.012 349.452 196.963 347.334 197.327C344.232 197.698 341.267 196.024 338.687 194.254C337.247 193.376 336.019 192.19 335.091 190.782C332.702 186.584 335.791 181.178 339.84 179.395C344.328 177.46 349.104 182.413 352.632 184.732Z",
    fill: "url(#paint16_linear_2292_75315)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2292_75315",
    x1: 379.176,
    y1: 281.749,
    x2: 285.158,
    y2: 285.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2292_75315",
    x1: 53023.4,
    y1: 77910.3,
    x2: 17799.9,
    y2: 55720.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2292_75315",
    x1: 50203.9,
    y1: 7268.68,
    x2: 50207.4,
    y2: 7913.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2292_75315",
    x1: 8171,
    y1: 4032.53,
    x2: 8051.49,
    y2: 5172.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2292_75315",
    x1: 355.857,
    y1: 229.474,
    x2: 384.904,
    y2: 256.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2292_75315",
    x1: 53106.3,
    y1: 18813.1,
    x2: 44003,
    y2: 46015.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2292_75315",
    x1: 256.389,
    y1: 490.848,
    x2: 171.209,
    y2: 253.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2292_75315",
    x1: 10223.5,
    y1: 1142.63,
    x2: 10237.9,
    y2: 1505.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2292_75315",
    x1: 7222.19,
    y1: 3415.47,
    x2: 6748.27,
    y2: 4922.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2292_75315",
    x1: 31606.6,
    y1: 8174.51,
    x2: 30127.5,
    y2: 9771.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2292_75315",
    x1: 9801.1,
    y1: 4507.46,
    x2: 9321.71,
    y2: 4585.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2292_75315",
    x1: 17344.2,
    y1: 6847.36,
    x2: 15316,
    y2: 7517.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2292_75315",
    x1: 93.2914,
    y1: 92.1874,
    x2: 85.1032,
    y2: 255.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2292_75315",
    x1: 9879.79,
    y1: 8690.4,
    x2: 8352.94,
    y2: 12318.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2292_75315",
    x1: 7009.45,
    y1: 3419.31,
    x2: 7059.06,
    y2: 2622.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2292_75315",
    x1: 13255.5,
    y1: 5279.75,
    x2: 13525.5,
    y2: 6081.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2292_75315",
    x1: 5849.2,
    y1: 3060.53,
    x2: 5645.35,
    y2: 3550.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2569447000323778622b94b2161ea652.svg";
export { ForwardRef as ReactComponent };